/* eslint-disable react/prefer-stateless-function,jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-wrap-multilines */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

export default class ModalError extends Component {

  render() {
    return (
      <Modal
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            padding: 20,
          },
          content: {
            position: 'relative',
            border: 'none',
            background: 'red',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '20px',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          },
        }}
        ariaHideApp={false}
        isOpen={this.props.isOpen}
        aria={{
          labelledby: 'heading',
          describedby: 'full_description',
        }}
      >
        <i
          onClick={this.props.toggleModalError}
          style={{
            cursor: 'pointer',
            position: 'absolute',
            right: '2px',
            fontSize: '24px',
            top: '0px',
            color: 'white',
          }}
          className="fa fa-times-circle-o"
        />
        <span>
          <i style={{ color: 'white', fontSize: 20 }} className="fa fa-exclamation-triangle" aria-hidden="true" />
          <span style={{ color: 'white', marginLeft: 10, fontSize: 20 }}>Attention</span>
        </span>
        <div id="full_description">
          <ul>
            {this.props.data.length > 0 && this.props.data.map((obj, idx) =>
              <li
                style={{ color: 'white' }}
                key={idx}
              >
                {obj.message}
              </li>)
            }
          </ul>
          <span style={{ color: 'white' }}>
            <FormattedMessage {...messages.description} />
          </span>
        </div>
      </Modal>
    );
  }
}
ModalError.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.array,
  toggleModalError: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Validation/ModaError.js